export default __webpack_public_path__ + "static/media/8.bb04ce11.jpg";